<template>
  <main class="main create_estimate_common" role="main" v-if="isCompleted">
    <!-- <div class="step">
      <div class="point on"></div>
      <div class="step_txt">Step1. 견적요청</div>
    </div> -->
    <div class="main_con" id="con_fixed">
      <div class="e_con">
        <div class="step_bar" v-if="isCurStep > 0">
          <div class="bar">
            <div class="state" :style="{ width: widthLine }"></div>
          </div>
        </div>

        <!-- step_1 / step_2 start -->
        <div class="e_step_qa" v-show="step_1">
          <div class="question">누구의 폰을<br />구매 하시는건가요?</div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              ><input
                type="radio"
                v-model="request.buyer"
                name="m_01"
                :value="{
                  name: '본인',
                  value: 1,
                }"
                @click="step_next(1, 1)"
              />
              <div class="txt"></div>
              <div class="txt02">본인</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.buyer"
                name="m_01"
                :value="{
                  name: '부모님/자녀 등',
                  value: 2,
                }"
                @click="step_next(1, 2)"
              />
              <div class="txt"></div>
              <div class="txt02">부모님/자녀 등</div>
            </label>
          </div>
          <div class="step_qa_sub" v-show="step_2">
            <div class="question_sub">
              사용자 연령대를 선택해 주세요
              <div class="question_sub_txt">
                연령에 맞는 요금제 추천에 활용됩니다
              </div>
            </div>

            <div class="answer_wrap check_table" data-columns="">
              <label
                v-for="(useAgeItem, useAgeIndex) in useAge"
                :key="useAgeIndex"
              >
                <input
                  type="radio"
                  v-model="request.age"
                  name="m_02"
                  :value="{
                    name: useAgeItem.name,
                    value: useAgeItem.value,
                  }"
                  @click="step_next(2, useAgeIndex + 1)"
                />
                <div class="txt"></div>
                <div class="txt02">
                  {{ useAgeItem.name }}
                </div>
              </label>
            </div>
          </div>
        </div>
        <!-- step_1 / step_2 end -->

        <!-- step_3 start -->
        <div class="e_step_qa" v-show="step_3">
          <div class="question">
            {{ user.nickname }}님은<br />
            <span>{{ myTelecom }} | {{ myDevice }}</span
            >를 이용 중이시군요!
          </div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              ><input
                type="radio"
                v-model="request.isCurTelecom"
                name="m_03"
                :value="{
                  name: '네, 맞아요.',
                  value: 1,
                }"
                @click="step_next(3, 1)"
              />
              <div class="txt"></div>
              <div class="txt02">네, 맞아요.</div>
            </label>
            <label class="answer_label"
              ><input
                type="radio"
                v-model="request.isCurTelecom"
                name="m_03"
                :value="{
                  name: '아니오, 다른걸 이용 중이에요.',
                  value: 2,
                }"
                @click="step_next(3, 2)"
              />
              <div class="txt"></div>
              <div class="txt02">아니오, 다른걸 이용 중이에요.</div>
            </label>
          </div>
        </div>
        <!-- step_3 end -->

        <!-- step_4 start -->
        <div class="e_step_qa" v-show="step_4">
          <div class="question">현재 사용중인<br />통신사를 선택하세요.</div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              ><input
                type="radio"
                v-model="request.curTelecom"
                name="m_04"
                :value="{
                  name: 'SKT',
                  value: 'SKT',
                }"
                @click="step_next(4, 1)"
              />
              <div class="txt"></div>
              <div class="txt02">SKT</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.curTelecom"
                name="m_04"
                :value="{
                  name: 'KT',
                  value: 'KT',
                }"
                @click="step_next(4, 2)"
              />
              <div class="txt"></div>
              <div class="txt02">KT</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.curTelecom"
                name="m_04"
                :value="{
                  name: 'LGU+',
                  value: 'LGUPLUS',
                }"
                @click="step_next(4, 3)"
              />
              <div class="txt"></div>
              <div class="txt02">LGU+</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.curTelecom"
                name="m_04"
                :value="{
                  name: '알뜰폰',
                  value: 'MVNO',
                }"
                @click="step_next(4, 4)"
              />
              <div class="txt"></div>
              <div class="txt02">알뜰폰</div>
            </label>
          </div>
        </div>
        <!-- step_4 end -->

        <!-- step_5 / step_6 start -->
        <div class="e_step_qa" v-show="step_5">
          <div class="question">
            현재 이용중인 통신사를<br />변경할 의향이 있으신가요?
          </div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              ><input
                type="radio"
                v-model="request.telecomUse"
                name="m_05"
                :value="{
                  name: '네 (번호이동)',
                  value: '번호이동',
                  joinType: 'MNP',
                }"
                @click="step_next(5, 1)"
              />
              <div class="txt"></div>
              <div class="txt02">네 (번호이동)</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.telecomUse"
                name="m_05"
                :value="{
                  name: '아니오 (기기변경)',
                  value: '기기변경',
                  joinType: 'CHANGE',
                }"
                @click="step_next(5, 2)"
              />
              <div class="txt"></div>
              <div class="txt02">아니오 (기기변경)</div>
            </label>
            <label
              ><input
                type="radio"
                v-model="request.telecomUse"
                name="m_05"
                :value="{
                  name: '신규가입',
                  value: '신규가입',
                  joinType: 'NEW',
                }"
                @click="step_next(5, 3)"
              />
              <div class="txt"></div>
              <div class="txt02">신규가입</div>
            </label>
          </div>
          <div
            class="step_qa_sub sub_3"
            :class="{ sub_4: selectTelecomSub.length == 4 }"
            v-show="step_6"
          >
            <div class="question_sub">{{ telecomSubTitle }}</div>
            <div class="answer_wrap check_table" data-columns="">
              <label
                class="answer_label"
                v-for="(item, index) in selectTelecomSub"
                :key="index"
              >
                <input
                  type="radio"
                  v-model="request.selectTelecom"
                  name="m_06"
                  :value="{
                    name: item.name,
                    value: item.value,
                  }"
                  @click="step_next(6, item.value)"
                />
                <div class="txt"></div>
                <div class="txt02">
                  {{ item.name }}
                </div>
              </label>
            </div>
          </div>
        </div>
        <!-- step_5 / step_6 end -->

        <!-- step_7 start -->
        <div class="e_step_qa" v-show="step_7">
          <div class="question">
            <span>알뜰폰</span>도 <br />다양해서 선택이 필요해요!
          </div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              v-for="(item, index) in this.mobileTelecoms.content"
              :key="index"
            >
              <input
                type="radio"
                v-model="request.mvnoTelecom"
                name="m_07"
                :value="{
                  name: item.telecomName,
                  value: item.telecomId,
                }"
                @click="step_next(7, item.telecomId)"
              />
              <div class="txt"></div>
              <div class="txt02">{{ item.telecomName }}</div>
            </label>
          </div>
        </div>
        <!-- step_7 end -->

        <!-- step_8 start -->
        <div class="e_step_qa" v-show="step_8">
          <div class="question">
            한달 데이터 사용량은 <br />어떻게 되시나요?
            <div class="question_txt_3">
              의무요금제 사용 후, 최적의 요금제를 추천해 드려요
            </div>
          </div>
          <div class="answer_wrap check_table" data-columns="">
            <label
              v-for="(useDataItem, useDataIndex) in useData"
              :key="useDataIndex"
            >
              <input
                type="radio"
                v-model="request.dataUse"
                name="m_08"
                :value="{
                  name: useDataItem.name,
                  value: useDataItem.value,
                }"
                @click="step_next(8, useDataIndex + 1)"
              />
              <div class="txt"></div>
              <div class="txt02">
                {{ useDataItem.name }}
                <div class="txt02_sub">{{ useDataItem.sub }}</div>
              </div>
            </label>
          </div>
        </div>
        <!-- step_8 end -->

        <!-- step_9 start -->
        <div class="e_step_qa" v-show="step_9">
          <div class="question">구매를 원하는<br />휴대폰을 선택해주세요!</div>
          <div ref="mobileDeviceComponent">
            <Device
              :show="step_9"
              @deviceSel="deviceSel"
              @categorySel="categorySel"
              :mobileCategoryMain="mobileCategoryMain"
              :mobileCategorySub="mobileCategorySub"
              :telecomId="mobileTelecomId"
              ref="mobileDevice"
            />
          </div>
        </div>
        <!-- step_9 end -->

        <!-- step_10 start -->
        <div class="e_step_qa" v-show="step_10">
          <div class="question">
            견적을 받아볼 동네를<br />선택해주세요!
            <div class="question_txt">(최대 2곳 선택가능)</div>
          </div>
          <div class="answer_wrap" data-columns="">
            <label class="area on" @click="goSelectArea('1')">
              <div class="txt">{{ isAreaName_1 }}</div>
              <div class="txt02"></div>
            </label>
            <label class="area label" :class="{ on: isAreaId_2 }">
              <div class="txt" @click="goSelectArea('2')">
                {{ isAreaName_2 }}
              </div>
              <div class="txt02"></div>
              <div class="delImg" @click="areaDel()" v-if="isAreaId_2">
                <img
                  :src="
                    require('@/assets/front/images/v2/icons/ic_x_round.svg')
                  "
                />
              </div>
            </label>
          </div>
        </div>
        <!-- step_10 end -->

        <!-- step_11 start -->
        <div class="e_step_qa" v-show="step_11">
          <div class="question">
            입력하신 정보가 맞다면,<br />이제 견적을 받아볼까요?
            <div class="question_txt_2">
              견적을 요청하시면, 매장 방문 개통부터 택배와 퀵으로 받을 수 있는
              비대면 개통 견적까지 모두 받아볼 수 있어요!
            </div>
          </div>
          <div class="result_wrap">
            <div class="result_inner">
              <div class="list">
                <div class="txt">구매 대상</div>
                <div class="txt02">
                  {{ request.buyer.name }} - {{ request.age.name }}
                </div>
              </div>
              <div class="list">
                <div class="txt">현재 이용 내역</div>
                <div class="txt02" v-if="request.isCurTelecom.value == 1">
                  {{ request.curTelecom.name }} | {{ myDevice }}
                </div>
                <div class="txt02" v-else>
                  {{ request.curTelecom.name }}
                </div>
              </div>
              <div class="list">
                <div class="txt">희망 통신사</div>
                <div class="txt02" v-if="request.selectTelecom.value == 'MVNO'">
                  {{ request.mvnoTelecom.name }}
                  {{ ` (${request.telecomUse.value})` }}
                </div>
                <div class="txt02" v-else>
                  {{ request.selectTelecom.name }}
                  {{ ` (${request.telecomUse.value})` }}
                </div>
              </div>
              <div class="list">
                <div class="txt">구매 모델</div>
                <div class="txt02" v-if="this.request.device.noColor">
                  {{ request.device.modelName }} | 색상상관없음
                </div>
                <div class="txt02" v-else>
                  {{ request.device.modelName }} |
                  {{ this.request.device.color }}
                </div>
              </div>
              <!-- <div class="list">
                <div class="txt">희망 요금제</div>
                <div class="txt02">{{ request.payment.planName }}</div>
              </div> -->
              <div class="list">
                <div class="txt">견적 받을 동네</div>
                <div
                  class="txt02"
                  v-if="request.location_1.areaId && !request.location_2.areaId"
                >
                  {{ request.location_1.areaName }}
                </div>
                <div class="txt02" v-else>
                  {{ request.location_1.areaName }}
                  {{ `, ${request.location_2.areaName}` }}
                </div>
              </div>
            </div>
          </div>
          <div class="notice_txt_wrap">
            <div class="notice_img_txt">
              <div class="img_1">
                <img src="@/assets/front/images/v2/etc/imoji_search.png" />
              </div>
              <div class="txt_1">
                휴대폰 개통 후 견적 내용과 개통 내용이 일치하는지
                <span class="rd">반드시 확인</span>하시기 바랍니다!
              </div>
            </div>
          </div>
        </div>
        <!-- step_11 end -->
      </div>
      <div class="btm_btn" v-if="step_11">
        <div class="btn_wrap">
          <button class="btn bo" @click="step_prev">
            뒤로가기
          </button>
          <button class="btn" @click="sendMobile">
            견적 요청하기
          </button>
        </div>
      </div>
    </div>
    <div class="btm_form_info mobile" v-if="step_11">
      <div class="info_img">
        <img
          :src="require('@/assets/front/images/new/img_txt_noti_hand.png')"
          alt=""
        />
      </div>
      <div class="info_txt">
        <div>견적 요청 후 일주일간 수정 및 재등록이</div>
        <div>불가하니 신중히 선택해주세요!</div>
      </div>
    </div>
    <div
      class="ic_back"
      v-if="!step_11 && !step_1 && !step_2"
      @click="step_prev"
    >
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_pre.svg`)"
        alt=""
      />
    </div>
    <div class="ic_next" v-if="step_10" @click="step_next(10, 1)">
      다음
      <img
        :src="require(`@/assets/front/images/mobile/ic_float_nxt_w.svg`)"
        alt=""
      />
    </div>
    <DesignPopup
      :show="designPopup"
      :data="{ type: 'alert', msg: msgPopup }"
      @close="designPopupclose"
    />
    <DesignPopup2
      :show="sendMobilePopup"
      :data="{
        title: '견적 받아보기 안내',
        type: 'confirm',
        msg: `매장에 견적을 요청할게요!<br />답변하신 내용을 바탕으로<br />매장들이 보내준 혜택을 한눈에 비교할 수 있어요!<br /><br />🔔진행 상황은 카카오톡 알림으로 바로 알려드려요.`,
      }"
      @close="sendMobilePopupClose"
    />
  </main>
</template>
<script>
import {
  mapActions as userMapActions,
  mapGetters as userMapGetters,
} from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import Device from '@/common/components/mobile/Device.vue';
import Payment from '@/common/components/mobile/Payment.vue';
import format from 'date-fns/format';
import DesignPopup from '@/common/components/modal/DesignPopup';
import {
  sleep,
  nativeDeviceInfo,
  connectedSocket,
  closeSocket,
  checkMobileOperatingSystem,
  setCallbackOnClickBackKey,
  nativeEnableBackKey,
  nativeDisableBackKey,
  jsonEscape,
  toBR,
  sdk_logEvent,
  sdk_logEventKakao,
} from '@common/lib/common/utils';

import DesignPopup2 from '@/common/components/modal/DesignPopup2';
export default {
  components: {
    Device,
    // Payment,
    DesignPopup,
    DesignPopup2,
  },
  data() {
    return {
      isMode: '', // 휴대폰스펙찾기 : MY_MOBILE, default : ''

      isTabFixed: false,
      isAreaFullName_1: '',
      isAreaName_1: '',
      isAreaId_1: 0,

      isAreaFullName_2: '',
      isAreaName_2: '동네를 선택해 주세요',
      isAreaId_2: 0,

      isCompleted: false,
      isCurStep: 1,
      selectedStep: [],
      selectedVal: [],
      selectedStepVal: [],
      step_1: true,
      step_2: false,
      step_3: false,
      step_4: false,
      step_5: false,
      step_6: false,
      step_7: false,
      step_8: false,
      step_9: false,
      step_10: false,
      step_11: false,
      // step_12: false,
      myTelecom: '',
      myDevice: '',
      telecomSubTitle: '',
      telecomSub: [
        { name: 'SKT', value: 'SKT' },
        { name: 'KT', value: 'KT' },
        { name: 'LGU+', value: 'LGUPLUS' },
        { name: '알뜰폰', value: 'MVNO' },
      ],
      selectTelecomSub: [
        { name: 'SKT', value: 'SKT' },
        { name: 'KT', value: 'KT' },
        { name: 'LGU+', value: 'LGUPLUS' },
        { name: '알뜰폰', value: 'MVNO' },
      ],
      request: {
        buyer: { name: '', value: 0 }, // 구매자
        age: { name: '', value: '' }, // 구매자 나이
        isCurTelecom: { name: '', value: '' }, // 시스템으로 현재 사용중인 통신사가 맞는지 확인 여부
        curTelecom: { name: '', value: '' }, // 현재 사용중인 통신사를 선택
        telecomUse: { name: '', value: '', joinType: '' }, // 통신사를 변경할지 여부 ( 네(번호이동), 아니오(기기변경), 신규가입 )
        selectTelecom: { name: '', value: '' }, // telecomUse (변경할지 여부)에서 (네, 신규가입)을 선택했을때 통신사를 선택
        mvnoTelecom: { name: '', value: '' }, // 알뜰폰 선택시 통신사 선택
        device: {
          id: 0,
          name: '',
          modelName: '',
          color: '',
          noColor: false,
          image: '',
          factoryPrice: 0,
        }, // 디바이스 선택
        dataUse: { name: '', value: '' }, // 데이터 양 사용 확인
        payment: { planId: 0, planName: '', planPrice: 0 }, // 요금제 선택
        location_1: { areaId: 0, areaName: '', areaFullName: '' }, // 견적받을 동네 1
        location_2: { areaId: 0, areaName: '', areaFullName: '' }, // 견적받을 동네 2
      },
      widthLine: '8%',
      widthLineA: {
        1: '8%',
        2: '16%',
        3: '24%',
        4: '32%',
        5: '40%',
        6: '48%',
        7: '56%',
        8: '64%',
        9: '77%',
        10: '88%',
        11: '100%',
      },
      // widthLine: '10%',
      // widthLineA: {
      //   1: '10%',
      //   2: '20%',
      //   3: '30%',
      //   4: '40%',
      //   5: '50%',
      //   6: '60%',
      //   7: '70%',
      //   8: '80%',
      //   9: '90%',
      //   10: '100%',
      // },
      dateY_12: format(new Date(), 'yyyy') - 12,
      dateY_18: format(new Date(), 'yyyy') - 18,

      mobileCategoryMain: [],
      mobileCategorySub: [],
      mobileTelecomId: '',

      myMobileModelName: '',

      designPopup: false,
      msgPopup: '',

      useAge: [
        { name: '일반(만 35세~64세 이하)', value: 'B_35_64' },
        { name: '청년(만 19세~34세 이하)', value: 'B_19_34' },
        { name: '청소년(만 12세~18세 이하)', value: 'B_12_18' },
        { name: '키즈(만 12세 이하)', value: 'U_12' },
        { name: '어르신(만 65세 이상)', value: 'O_65' },
      ],

      useData: [
        { name: '데이터 무제한', sub: '마음껏 사용해요', value: 'UNLIMITED' },
        {
          name: '50GB 이상',
          sub: '매일 1시간 이상 영상을 자주 시청해요',
          value: 'O_50G',
        },
        { name: '10GB 이상', sub: '음악을 자주 들어요', value: 'O_10G' },
        {
          name: '9GB 이하',
          sub: '웹 서핑과 카톡 위주로 사용해요',
          value: 'U_9G',
        },
        {
          name: '5GB 이하',
          sub: '거의 사용하지 않고 WIFI 이용해요',
          value: 'U_5G',
        },
      ],
      sendMobilePopup: false,
    };
  },
  async created() {
    // this.myTelecom = 'KT';
    // this.myDevice = '갤럭시 노트 20';
    this.isMode = this.$route.query.mode;
    if (this.isMode == 'MY_MOBILE') {
      this.myMobileModelName = localStorage.getItem('myMobileModelName');
    }

    await this.getMobileInfo();

    this.isCompleted = true;
    await this.getMyProfile();
    await this.getMyDevice();
  },
  mounted() {
    document.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll);
  },
  computed: {
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...mobileMapGetters({
      mobileTelecoms: mobileTypes.MOBILE_TELECOMS,
      mobileCategory: mobileTypes.MOBILE_CATEGORY,
      mobilePlanCategory: mobileTypes.MOBILE_PLAN_CATEGORY,
      mobilePlans: mobileTypes.MOBILE_PLANS,
      mobilePlanDetail: mobileTypes.MOBILE_PLAN_DETAIL,
      mobileRequestListIng: mobileTypes.MOBILE_REQUEST_LIST_ING,
      mobileRequestListEnd: mobileTypes.MOBILE_REQUEST_LIST_END,
    }),
  },
  methods: {
    ...userMapActions([userTypes.FETCH_ME, userTypes.FETCH_USER_DEVICE]),
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_TELECOMS,
      mobileTypes.SELECT_MOBILE_CATEGORY,
      mobileTypes.SELECT_MOBILE_PLAN_CATEGORY,
      mobileTypes.SELECT_MOBILE_PLANS,
      mobileTypes.SELECT_MOBILE_PLAN_DETAIL,
      mobileTypes.INSERT_MOBILE_REQUESTS,
    ]),
    async getMyDevice() {
      nativeDeviceInfo();
      await sleep(500);
      // this.myDevice = window.$bridge.deviceModelName || '';

      this.myDevice = await this[userTypes.FETCH_USER_DEVICE]({
        id: this.user.id,
      });

      if (this.myDevice != '') {
        const modelName = this.myDevice.split('의 ');
        console.log(modelName);
        this.myDevice = modelName.length == 1 ? this.myDevice : modelName[1];
      }

      this.myTelecom = window.$bridge.telecomName || '';
    },
    async getMyProfile() {
      await this[userTypes.FETCH_ME]();
      console.log('getMyProfile');
      console.log(this.user);
    },
    async step_next(curStep, curVal) {
      console.log('=======================');
      console.log(curStep + '/' + curVal);
      console.log('=======================');
      // step_1 선택시
      if (curStep == 1) {
        nativeEnableBackKey();
        this.step_1 = true;
        this.step_2 = true;
        this.step_3 = false;
        this.step_4 = false;

        this.request.age.name = '';
        this.request.age.value = '';

        this.request.isCurTelecom.name = '';
        this.request.isCurTelecom.value = '';
      } else if (curStep == 2) {
        nativeDisableBackKey();
        await sleep(200);
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = false;
        this.step_4 = false;
        this.step_5 = false;
        // console.log(this.myTelecom);
        const telecomNameCheckArr = [
          'LG U+',
          'LGU+',
          'SK Telecom',
          'SKTelecom',
          'SKT',
          'KT',
        ];
        // 대리구매 경우 또는 통신사가 SKT, KT, LGU+ 가 아닐때
        if (
          this.request.buyer.value == 2 ||
          this.myDevice == '' ||
          !telecomNameCheckArr.includes(this.myTelecom)
        ) {
          this.request.telecomUse.name = '';
          this.request.telecomUse.value = '';
          this.request.telecomUse.joinType = '';

          this.request.curTelecom.name = '';
          this.request.curTelecom.value = '';
          this.step_4 = true;
        } else {
          this.request.telecomUse.name = '';
          this.request.telecomUse.value = '';
          this.request.telecomUse.joinType = '';

          this.step_3 = true;
        }
      } else if (curStep == 3) {
        await sleep(200);
        this.step_3 = false;
        this.step_4 = false;
        this.step_5 = false;
        this.step_6 = false;
        this.step_8 = false;
        this.step_9 = false;

        // 통신사와 모델이 맞을 경우
        if (curVal == 1) {
          const te = this.telecomSub.find((e, i) => e.name === this.myTelecom);

          if (te) {
            if (te.name != '' && te.value != '') {
              // 내 통신사 저장 필요
              this.request.curTelecom.name = te.name;
              this.request.curTelecom.value = te.value;
              this.step_5 = true;
            }
          } else {
            this.request.curTelecom.name = '';
            this.request.curTelecom.value = '';
            this.step_4 = true;
          }
        } else {
          this.request.curTelecom.name = '';
          this.request.curTelecom.value = '';
          this.step_4 = true;
        }
      } else if (curStep == 4) {
        await sleep(200);
        this.request.telecomUse.name = '';
        this.request.telecomUse.value = '';
        this.request.telecomUse.joinType = '';

        this.step_4 = false;
        this.step_5 = true;
        this.step_6 = false;
        this.step_7 = false;
        this.step_8 = false;
        this.step_9 = false;
      } else if (curStep == 5) {
        await sleep(200);
        // console.log(this.request.curTelecom.name);
        // console.log('this.request.curTelecom.name');

        this.request.dataUse.name = '';
        this.request.dataUse.value = '';

        // 통신사 변경 및 신규
        if (curVal == 1 || curVal == 3) {
          this.step_5 = true;
          this.step_7 = false;
          this.step_8 = false;
          this.step_9 = false;
          this.step_10 = false;
          this.request.selectTelecom.name = '';
          this.request.selectTelecom.value = '';
          if (curVal == 1) {
            this.telecomSubTitle = '변경을 원하는 통신사를 선택해 주세요!';
            this.selectTelecomSub = [
              { name: 'SKT', value: 'SKT' },
              { name: 'KT', value: 'KT' },
              { name: 'LGU+', value: 'LGUPLUS' },
              { name: '알뜰폰', value: 'MVNO' },
            ];

            const findTe = this.selectTelecomSub.findIndex(
              (e, i) => e.name === this.request.curTelecom.name,
            );

            // console.log(findTe);
            // console.log(this.request);

            if (findTe >= 0) {
              this.selectTelecomSub.splice(findTe, 1);
            }
          } else {
            this.telecomSubTitle = '신규가입을 원하는 통신사를 선택해 주세요!';

            this.selectTelecomSub = [
              { name: 'SKT', value: 'SKT' },
              { name: 'KT', value: 'KT' },
              { name: 'LGU+', value: 'LGUPLUS' },
              { name: '알뜰폰', value: 'MVNO' },
            ];
          }
          this.request.selectTelecom.name = '';
          this.request.selectTelecom.value = '';
          this.step_6 = true;
        } else {
          this.step_5 = false;
          this.step_6 = false;
          this.step_7 = false;
          this.step_8 = false;
          this.step_9 = false;
          this.step_10 = false;
          // 통신사 그대로
          this.request.selectTelecom.name = this.request.curTelecom.name;
          this.request.selectTelecom.value = this.request.curTelecom.value;

          // 알뜰폰일 경우
          if (this.request.selectTelecom.value == 'MVNO') {
            await this.getTelecomMVNO();
            this.step_7 = true;
          } else {
            this.request.mvnoTelecom.name = '';
            this.request.mvnoTelecom.value = '';
            this.step_8 = true;
            await sleep(200);
            console.log(555555522222222);
            this.handleScrollReset();
            console.log(5555555222222222222222);
            if (this.myMobileModelName != '') {
              // this.selectDevice();
              this.$refs.mobileDevice.searchText = this.myMobileModelName;
            }
            await this.getDeviceList(this.request.curTelecom.value);
          }
        }
      } else if (curStep == 6) {
        await sleep(200);
        this.step_5 = false;
        this.step_6 = false;
        this.step_7 = false;
        this.step_8 = false;
        this.step_9 = false;
        this.step_10 = false;
        this.request.mvnoTelecom.name = '';
        this.request.mvnoTelecom.value = '';

        // 알뜰폰 선택시
        if (curVal == 'MVNO') {
          await this.getTelecomMVNO();
          this.step_7 = true;
        } else {
          this.step_8 = true;
          this.handleScrollReset();
          if (this.myMobileModelName != '') {
            this.$refs.mobileDevice.searchText = this.myMobileModelName;
          }
          await this.getDeviceList(curVal);
        }
      } else if (curStep == 7) {
        await sleep(200);
        this.request.dataUse.name = '';
        this.request.dataUse.value = '';

        this.step_7 = false;
        this.step_8 = true;
        console.log(7777777);
        this.handleScrollReset();
        console.log(777777777777);
        this.step_9 = false;
        this.step_10 = false;
        if (this.myMobileModelName != '') {
          this.$refs.mobileDevice.searchText = this.myMobileModelName;
        }
        await this.getDeviceList(curVal);
      } else if (curStep == 8) {
        await sleep(200);
        this.step_7 = false;
        this.step_8 = false;
        this.step_9 = true;
        this.step_10 = false;
        this.step_11 = false;
      } else if (curStep == 9) {
        await sleep(200);
        this.step_1 = false;
        this.step_9 = false;
        this.setArea();
        await this.getPaymentCategory();
        this.step_10 = true;
        this.handleScrollReset();
        this.step_11 = false;
      } else if (curStep == 10) {
        this.step_1 = false;
        this.step_10 = false;
        this.step_11 = true;
        // this.step_12 = false;
      } else if (curStep == 11) {
        // this.step_11 = false;
        // this.step_12 = true;
      }

      this.isCurStep = curStep;
      this.widthLine = this.widthLineA[curStep + 1];

      const result_step = this.selectedStep.filter(item => item === curStep);
      // console.log('값이 30 이 아닌 값들 구하기');
      // console.log(result_step); // [10, 20, 40, 50]
      if (result_step.length == 0) {
        this.selectedStep.push(curStep);
        // this.selectedVal.push(curVal);
        this.selectedStepVal.push({ cur: curStep, val: curVal });
      } else {
        const result_val = this.selectedStepVal.filter(
          item => item.curVal === curVal,
        );

        if (result_val.length == 0) {
          this.selectedStepVal.pop();
          this.selectedStepVal.push({ cur: curStep, val: curVal });
        }
      }
      // console.log('curVal = ' + curVal);
      // console.log('this.selectedStepVal');
      // console.log(this.selectedStepVal);
      localStorage.setItem('mobileEstimateStep', this.isCurStep);

      console.log(
        'buyer / ' + this.request.buyer.name + ' / ' + this.request.buyer.value,
      );
      console.log(
        'age / ' + this.request.age.name + ' / ' + this.request.age.value,
      );
      console.log(
        'curTelecom / ' +
          this.request.curTelecom.name +
          ' / ' +
          this.request.curTelecom.value,
      );
      console.log(
        'telecomUse / ' +
          this.request.telecomUse.name +
          ' / ' +
          this.request.telecomUse.value +
          ' / ' +
          this.request.telecomUse.joinType,
      );
      console.log(
        'dataUse / ' +
          this.request.dataUse.name +
          ' / ' +
          this.request.dataUse.value,
      );
      console.log(
        'device / ' +
          this.request.device.id +
          ' / ' +
          this.request.device.name +
          ' / ' +
          this.request.device.modelName +
          ' / ' +
          this.request.device.color +
          ' / ' +
          this.request.device.noColor +
          ' / ' +
          this.request.device.image +
          ' / ' +
          this.request.device.factoryPrice,
      );
      console.log(
        'isCurTelecom / ' +
          this.request.isCurTelecom.name +
          ' / ' +
          this.request.isCurTelecom.value,
      );
      console.log(
        'location_1 / ' +
          this.request.location_1.areaId +
          ' / ' +
          this.request.location_1.areaName +
          ' / ' +
          this.request.location_1.areaFullName,
      );
      console.log(
        'location_2 / ' +
          this.request.location_2.areaId +
          ' / ' +
          this.request.location_2.areaName +
          ' / ' +
          this.request.location_2.areaFullName,
      );
      console.log(
        'mvnoTelecom / ' +
          this.request.mvnoTelecom.name +
          ' / ' +
          this.request.mvnoTelecom.value,
      );
      console.log(
        'selectTelecom / ' +
          this.request.selectTelecom.name +
          ' / ' +
          this.request.selectTelecom.value,
      );
    },
    step_prev() {
      console.log(this.isCurStep);
      if (this.isCurStep < 9) {
        this.localStroageRemove();
      }

      this.selectedStep.pop(); // 마지막 제거
      this.selectedStepVal.pop();

      this.step_next(
        this.selectedStepVal[this.selectedStepVal.length - 1]['cur'],
        this.selectedStepVal[this.selectedStepVal.length - 1]['val'],
      );
    },
    localStroageRemove() {
      localStorage.removeItem('mobileEstimate');
      localStorage.removeItem('mobileEstimateStep');
      localStorage.removeItem('mobileSelectedStepVal');
      localStorage.removeItem('mobileSelectedStep');
      localStorage.removeItem('mobileArea_1');
      localStorage.removeItem('mobileArea_2');
    },
    deviceSel(
      selColor,
      noColor,
      deviceId,
      deviceName,
      modelName,
      deviceImage,
      factoryPrice,
    ) {
      // alert(2);
      console.log(selColor);
      console.log(noColor);
      console.log(deviceId);
      console.log(deviceName);
      console.log(modelName);
      console.log(deviceImage);
      console.log(factoryPrice);

      this.request.device.id = deviceId;
      this.request.device.name = deviceName;
      this.request.device.modelName = modelName;
      this.request.device.color = selColor;
      this.request.device.noColor = noColor;
      this.request.device.image = deviceImage;
      this.request.device.factoryPrice = factoryPrice;
      this.step_next(9, '');
    },
    async categorySel() {
      //await this.handleScrollReset();
      // this.$refs.mobileDeviceComponent.scrollIntoView({ behavior: 'auto' });
      setTimeout(() => {
        window.scrollTo(0, 190);
      }, 100);
    },
    paymentSel() {
      // alert(4);
      // this.request.payment.planId = this.$refs.payment.planId;
      // this.request.payment.planName = this.$refs.payment.planName;
      // this.request.payment.planPrice = this.$refs.payment.planPrice;
      // this.step_next(10, '');
    },
    goSelectArea(sel) {
      console.log('this.user');
      console.log(this.user);

      console.log('this.selectedStepVal2222');
      console.log(this.selectedStepVal);

      localStorage.setItem('mobileEstimate', JSON.stringify(this.request));
      localStorage.setItem(
        'mobileSelectedStepVal',
        JSON.stringify(this.selectedStepVal),
      );
      localStorage.setItem(
        'mobileSelectedStep',
        JSON.stringify(this.selectedStep),
      );

      if (this.user.emdAreaName != null) {
        let codeType = 'e';
        let areaId = this.user.emdAreaId;
        if (this.user.admName) {
          const admArea = JSON.parse(this.user.admName);
          areaId = admArea.id;
          codeType = 'a';
        }
        this.$router.push({
          name: 'Auth.RegionSelected',
          query: {
            //areaName: this.user.emdAreaName.split(' ')[2],
            areaName: this.user.emdAreaName.substring(
              this.user.emdAreaName.lastIndexOf(' ') + 1,
            ),
            areaFullName: this.user.emdAreaName,
            areaId,
            codeType,
            from: 'Mobile_' + sel,
          },
        });
      } else {
        this.$router.push({
          name: 'Auth.Region',
          query: { from: 'Mobile_' + sel, isAreaValue: 'No' },
        });
      }
    },
    async getMobileInfo() {
      let mobileEstimateData = await localStorage.getItem('mobileEstimate');
      let mobileEstimateStep = await localStorage.getItem('mobileEstimateStep');
      let mobileSelectedStepVal = await localStorage.getItem(
        'mobileSelectedStepVal',
      );
      let mobileSelectedStep = await localStorage.getItem('mobileSelectedStep');

      console.log('mobileEstimateData');
      console.log(mobileEstimateData);
      console.log('mobileEstimateStep');
      console.log(mobileEstimateStep);

      this.isAreaId_1 = this.user.emdAreaId;
      this.isAreaName_1 = this.user.emdAreaNameShort;
      this.isAreaFullName_1 = this.user.emdAreaName;

      mobileEstimateStep = parseInt(mobileEstimateStep, 10);

      if (mobileEstimateStep == 9 && mobileEstimateData) {
        this.isCurStep = mobileEstimateStep;

        this.request = JSON.parse(mobileEstimateData);
        this.selectedStepVal = JSON.parse(mobileSelectedStepVal);
        this.selectedStep = JSON.parse(mobileSelectedStep);

        // sleep(2000);

        this.step_next(this.isCurStep, 0);

        let mobileArea_1 = await localStorage.getItem('mobileArea_1');
        let mobileArea_2 = await localStorage.getItem('mobileArea_2');

        if (mobileArea_1) {
          mobileArea_1 = JSON.parse(mobileArea_1);
          this.isAreaId_1 = mobileArea_1.areaId;
          this.isAreaName_1 = mobileArea_1.areaName;
          this.isAreaFullName_1 = mobileArea_1.areaFullName;
        }

        if (mobileArea_2) {
          mobileArea_2 = JSON.parse(mobileArea_2);
          this.isAreaId_2 = mobileArea_2.areaId;
          this.isAreaName_2 = mobileArea_2.areaName;
          this.isAreaFullName_2 = mobileArea_2.areaFullName;
        }
      }
    },
    // 알뜰폰 통신사 가져오기
    async getTelecomMVNO() {
      let params = { telecomType: 'MVNO' };
      await this[mobileTypes.SELECT_MOBILE_TELECOMS](params);
      console.log('mobileTelecoms');
      console.log(this.mobileTelecoms);
    },
    // 단말 카테고리 및 목록 가져오기
    async getDeviceList(telecomId) {
      // alert(telecomId);
      this.mobileTelecomId = telecomId;

      let params = { id: telecomId };
      await this[mobileTypes.SELECT_MOBILE_CATEGORY](params);
      console.log('mobileCategory');
      console.log(this.mobileCategory);

      this.mobileCategoryMain = this.mobileCategory.content.filter(
        v => v.categoryLevel === 'MAIN',
      );
      console.log(this.mobileCategoryMain);

      this.mobileCategorySub = this.mobileCategory.content.filter(
        v => v.categoryLevel === 'SUB',
      );
      console.log(this.mobileCategorySub);

      await this.$refs.mobileDevice.searchDevice();

      sleep(100);
      // 휴대폰 스펙 찾기에서 들어올 경우 - 선택한 디바이스가 있는지 확인 후 처리
      if (this.isMode == 'MY_MOBILE' && this.myMobileModelName != '') {
        console.log('this.$refs.mobileDevice.mobileDevice');
        console.log(this.$refs.mobileDevice.mobileDevice);

        const mobileDevice = this.$refs.mobileDevice.mobileDevice;

        if (mobileDevice.count < 1) {
          // alert('없음');
          this.designPopup = true;
          this.msgPopup =
            '고객님께서 선택하신 <br />휴대폰 [' +
            this.myMobileModelName +
            ']은 <br />' +
            this.request.selectTelecom.name +
            ' 통신사에는 없는 모델입니다. <br /><br />통신사 또는 휴대폰을 다시 선택해 주세요.';
        } else if (mobileDevice.count == 1) {
          await this.$refs.mobileDevice.deviceInfo(
            mobileDevice.content[0].deviceId,
            mobileDevice.content[0].deviceName,
            mobileDevice.content[0].modelName,
          );
        } else {
          // alert('2개 이상');
        }
      }
    },
    async getPaymentCategory() {
      console.log(this.request.selectTelecom.value);
      console.log(this.request.dataUse.value);
      console.log(this.request.device.id);

      if (this.request.selectTelecom.value == 'MVNO') {
        this.mobileTelecomId = this.request.mvnoTelecom.value;
      } else {
        this.mobileTelecomId = this.request.selectTelecom.value;
      }

      let params = {
        telecomId: this.mobileTelecomId,
        planGroup: '',
        deviceId: this.request.device.id,
      };
      await this[mobileTypes.SELECT_MOBILE_PLAN_CATEGORY](params);

      console.log('this.mobilePlanCategory');
      console.log(params);
      console.log(this.mobilePlanCategory);

      // if (this.request.dataUse.value != 'ALL') {
      //   var mobilePlanCategory = this.mobilePlanCategory.content.categories.find(
      //     v => v.selectYn === 'Y',
      //   );

      // this.$refs.payment.categoryName = mobilePlanCategory.categoryName;
      // this.$refs.payment.categoryId = mobilePlanCategory.categoryId;
      // } else {
      // this.$refs.payment.categoryName = '';
      // this.$refs.payment.categoryId = 0;
      // }

      // if (this.mobilePlanCategory.content.networks != null) {
      //   var mobilePlanNetwork = this.mobilePlanCategory.content.networks.find(
      //     v => v.selectYn === 'Y',
      //   );
      //   this.$refs.payment.networkType = mobilePlanNetwork.networkType;
      // }

      // console.log(mobilePlanCategory);

      // console.log('mobilePlanCategory');
      // console.log(this.mobilePlanCategory);

      // await this.getPaymentList();
    },
    async getPaymentList() {
      let params = {
        callPart: 'CUSTOMER',
        telecomId: this.mobileTelecomId,
        categoryId: this.$refs.payment.categoryId,
        orderType: this.$refs.payment.paymentSortVal,
        deviceId: this.request.device.id,
        networkType: this.$refs.payment.networkType,
        // keyword: this.$refs.payment.keyword,
      };
      await this[mobileTypes.SELECT_MOBILE_PLANS](params);

      console.log(params);

      console.log('mobilePlans');
      console.log(this.mobilePlans);
    },
    handleScrollReset() {
      this.$refs.mobileDevice.isTabFixed = false;
      // this.$refs.payment.isTabFixed = false;
    },
    handleScroll() {
      if (this.step_8) {
        const target = this.$refs.mobileDeviceComponent;
        const targetTop = target.getBoundingClientRect().top;
        console.log('targetTop = ' + targetTop);

        // const targetCon = this.$refs.mobileDevice.$refs.list_con_wrap;
        // const targetTopCon = targetCon.getBoundingClientRect().top;
        // console.log('targetTopCon = ' + targetTopCon);

        if (targetTop <= 53) {
          this.$refs.mobileDevice.isTabFixed = true;
        } else {
          this.$refs.mobileDevice.isTabFixed = false;
        }
      } else if (this.step_10) {
        const target = this.$refs.mobilePaymentComponent;
        const targetTop = target.getBoundingClientRect().top;
        console.log('targetTop = ' + targetTop);

        // if (targetTop <= 53) {
        //   this.$refs.payment.isTabFixed = true;
        // } else {
        //   this.$refs.payment.isTabFixed = false;
        // }
      }
    },
    setArea() {
      console.log(this.isAreaFullName_1);
      console.log(this.isAreaName_1);
      console.log(this.isAreaId_1);
      console.log(this.isAreaFullName_2);
      console.log(this.isAreaName_2);
      console.log(this.isAreaId_2);

      this.request.location_1.areaId = this.isAreaId_1;
      this.request.location_1.areaName = this.isAreaName_1;
      this.request.location_1.areaFullName = this.isAreaFullName_1;
      this.request.location_2.areaId = this.isAreaId_2;
      this.request.location_2.areaName =
        this.isAreaId_2 == 0 ? '' : this.isAreaName_2;
      this.request.location_2.areaFullName =
        this.isAreaId_2 == 0 ? '' : this.isAreaFullName_2;
    },
    sendMobile() {
      this.sendMobilePopup = true;
    },
    sendMobilePopupClose(checked) {
      if (checked) {
        // 현재 사용하는 통신사와 핸드폰이 아니면
        if (this.request.isCurTelecom.value == 2) {
          this.myDevice = '';
        }

        var telecomIdVal, telecomNameVal;

        if (this.request.selectTelecom.value == 'MVNO') {
          telecomIdVal = this.request.mvnoTelecom.value;
          telecomNameVal = this.request.mvnoTelecom.name;
        } else {
          telecomIdVal = this.request.selectTelecom.value;
          telecomNameVal = this.request.selectTelecom.name;
        }

        let params = {
          telecomId: telecomIdVal, // 통신사 id
          telecomName: telecomNameVal, // 통신사 명
          joinType: this.request.telecomUse.joinType, // 가입유형
          deviceId: this.request.device.id, // 단말 ID
          deviceName: this.request.device.name, // 단말 명
          modelName: this.request.device.modelName, // 모델 명
          deviceColor:
            this.request.device.noColor == true
              ? '색상상관없음'
              : this.request.device.color, // 단말색상
          deviceImage: this.request.device.image, // 단말기 대표이미지
          factoryPrice: this.request.device.factoryPrice, // 출고가
          planId: this.request.payment.planId, // 요금제 ID
          planName: this.request.payment.planName, // 요금제 명
          planPrice: this.request.payment.planPrice, // 월요금
          target: this.request.buyer.value, // 구매자
          targetDetail: this.request.age.value, // 구매자 연령
          useTelecomName: this.request.curTelecom.name, // 사용중 통신사
          useDeviceName: this.myDevice, // 사용중 단말
          areaId1: this.request.location_1.areaId, // 지역코드 1
          areaName1: this.request.location_1.areaName, // 지역
          areaFullName1: this.request.location_1.areaFullName,
          areaId2: this.request.location_2.areaId,
          areaName2: this.request.location_2.areaName,
          areaFullName2: this.request.location_2.areaFullName,
          data: this.request.dataUse.value,
        };

        console.log(params);

        this[mobileTypes.INSERT_MOBILE_REQUESTS](params).then(() => {
          this.localStroageRemove();
          nativeEnableBackKey();
          sdk_logEvent('MOBILE_ESTIMATE', {
            user_id: this.user.id,
          });
          sdk_logEventKakao('MOBILE_ESTIMATE');
          sleep(100);
          this.$router.push({ name: 'Mobile.List' });
        });
      }

      this.sendMobilePopup = false;
    },
    selectDevice() {
      this.$refs.mobileDevice.searchText = this.myMobileModelName;
      this.$refs.mobileDevice.searchDevice();
    },
    designPopupclose() {
      this.designPopup = false;
      this.$refs.mobileDevice.searchText = '';
      this.$refs.mobileDevice.searchDevice();
    },
    areaDel() {
      this.isAreaFullName_2 = '';
      this.isAreaName_2 = '동네를 선택해 주세요';
      this.isAreaId_2 = 0;

      this.request.location_2.areaId = 0;
      this.request.location_2.areaName = '';
      this.request.location_2.areaFullName = '';

      localStorage.removeItem('mobileArea_2');
    },
  },
};
</script>
